(function (win, $) {
    'use strict';

    var mobileMaxWidth = 649,
        count = 0,
        lastWindowSize;

    function getWindowSize() {
        var width = mobileMaxWidth + 1;
        if ((win && win.innerWidth) || (screen && screen.width)) {
            width = win.innerWidth || screen.width;
        }
        return width;
    }

    function shouldBeOpened(collapse) {
        var isMobile = getWindowSize() <= mobileMaxWidth;
        collapse = collapse || 'mobile';
        return !((isMobile && collapse.match(/mobile|both/)) ||
            (!isMobile && collapse.match(/full|both/)));
    }

    function setState($ctr, isClick) {
        var isOpened = !$ctr.hasClass('collapsed'),
            data = $ctr.data() || { collapse: 'mobile' },
            $exp = $('.expandable', $ctr),
            shouldOpen = isOpened,
            $link = $('.expandable-toggle', $ctr),
            isChanged;

        if (isClick) {
            $ctr.data('dirty', true);
            shouldOpen = !isOpened;
        }
        else if (!data.dirty) {
            isChanged = shouldBeOpened(data.collapse) !== isOpened;
            shouldOpen = isChanged ? !isOpened : isOpened;
        }
        if (shouldOpen) {
            $exp[isClick ? 'slideDown' : 'show'](function () {
                $ctr.removeClass('collapsed');
                $link.text($link.data()[shouldOpen ? 'c' : 'e']);
                $exp.attr('aria-expanded', 'true').focus();
            });
        } else {
            $exp[isClick ? 'slideUp' : 'hide'](function () {
                $ctr.addClass('collapsed');
                $link.text($link.data()[shouldOpen ? 'c' : 'e']);
                if (isClick) {
                    $link.focus();
                }
                $exp.attr('aria-expanded', 'false');
            });
        }
    }

    $(function () {
        lastWindowSize = getWindowSize();

        $('.expandable').each(function () {
            var id = win.dk.generateId(),
                $exp = $(this).wrap('<div class="dk-expandable"/>').attr({ 'id': id, 'role': 'region', 'tabindex': -1 }),
                $ctr = $exp.parent(),
                collapse = ($exp.attr('data-collapse') || 'mobile').toLowerCase().replace(/\s*/g, '');
            $ctr.data('collapse', collapse).prepend(
                $('<p/>').append(
                    $('<a href="javascript:void(0)" class="expandable-toggle"/>').data({
                        e: $exp.attr('data-expand-text') || 'Show description',
                        c: $exp.attr('data-collapse-text') || 'Hide description'
                    }).attr('aria-controls', id).on('click', function (e) {
                        e.preventDefault();
                        setState($ctr, true);
                        return false;
                    })
                )
            );
            setState($ctr);
            count++;
        });

        if (count > 0) {
            $(win).on('resize orientationchange', function () {
                var winSize = getWindowSize();
                if ((lastWindowSize > mobileMaxWidth && winSize <= mobileMaxWidth) ||
                    (lastWindowSize <= mobileMaxWidth && winSize > mobileMaxWidth)) {
                    lastWindowSize = getWindowSize();
                    $('.dk-expandable').each(function () {
                        setState($(this));
                    });
                }
            });
        }
    });
})(window, window.jQuery);
